/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/017-headphones': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4.5 9h-1v7h1c.275 0 .5-.225.5-.5v-6c0-.275-.225-.5-.5-.5zM11.5 9c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5h1V9h-1z"/><path pid="1" d="M16 8A8 8 0 10.479 10.732 3.5 3.5 0 003 15.964V9.036a3.478 3.478 0 00-1.371.506 6.5 6.5 0 1112.743 0A3.484 3.484 0 0013 9.035v6.929a3.5 3.5 0 002.521-5.232C15.831 9.879 16 8.959 16 8z"/>'
  }
})
